"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
const react_1 = require("react");
const useResizeObserver_1 = __importDefault(require("./useResizeObserver"));
function checkOverflow(element) {
    if (!element) {
        return false;
    }
    const curOverflow = element.style.overflow;
    if (!curOverflow || curOverflow === "visible")
        element.style.overflow = "hidden";
    const isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;
    element.style.overflow = curOverflow;
    return isOverflowing;
}
function useIsOverflowing({ ref }) {
    const [isOverflowing, setIsOverflowing] = (0, react_1.useState)(checkOverflow(ref === null || ref === void 0 ? void 0 : ref.current));
    const callback = (0, react_1.useCallback)(() => {
        setIsOverflowing(checkOverflow(ref === null || ref === void 0 ? void 0 : ref.current));
    }, [ref, setIsOverflowing]);
    (0, useResizeObserver_1.default)({
        ref,
        callback,
        debounceTime: 0
    });
    return isOverflowing;
}
exports.default = useIsOverflowing;
